// extracted by mini-css-extract-plugin
module.exports = {"accordionTitleWrapper":"style_accordionTitleWrapper__DRzeH","accordionTitle":"style_accordionTitle__uscGJ","sectionTime":"style_sectionTime__5RCEA"};